<template>
  <div class="slider-container">
    <div
      v-for="item in boardStore.sliderColors"
      :key="item.id"
      class="slide"
      :class="{ 'slide--active': item.id === boardStore.board?.id }"
      :style="{
        'background-color': item.color
      }"
    />
  </div>
</template>
<script setup lang="ts">
import { useBoardStore } from '@/stores/useBoardStore'

const boardStore = useBoardStore()
</script>
<style lang="scss" scoped>
.slider-container {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: vh(10px);
}

.slide {
  width: vw(122px);
  height: vh(3px);
  margin: 0 vw(7px);
  opacity: 0.3;
  transition: 0.5s ease-out;
  transition-property: opacity, height;

  &--active {
    height: vh(10px);
    opacity: 1;
  }
}
</style>
